import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { FileManagerList } from '../FileManagerList/FileManagerList';

export const FileManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        File Manager
      </h1>
      <FileManagerList />
    </Layout>
  );
};
